import { Form as SuiForm } from 'semantic-ui-react';
import { generateTemplates } from '../Templates';
import { generateWidgets } from '../Widgets';
export function generateTheme() {
    return {
        templates: generateTemplates(),
        widgets: generateWidgets(),
        _internalFormWrapper: SuiForm,
    };
}
export default generateTheme();
//# sourceMappingURL=Theme.js.map